import { CIcon } from '~/icons/types'

export const ciFacebook: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M12 22.998c6.073 0 10.997-4.924 10.997-10.997 0-6.074-4.924-10.997-10.997-10.997C5.927 1.004 1.003 5.927 1.003 12S5.927 22.997 12 22.997Z',
      fill: 'url(#ee738ec7-9996-45ae-9eb4-cb7a3eafc255-__a)'
    },
    {
      d:
        'm16.3 14.992.5-3.1h-3.1v-2.3c0-.9.3-1.6 1.7-1.6H17v-2.8c-.862-.12-1.73-.187-2.6-.2-2.7 0-4.5 1.6-4.5 4.4v2.5H7v3.1h2.9v7.8a10.5 10.5 0 0 0 3.8.061v-7.86h2.6Z',
      fill: '#fff'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'facebook',
  type: 'solid',
  defs:
    '<linearGradient id="ee738ec7-9996-45ae-9eb4-cb7a3eafc255-__a" x1="12" x2="12" y1="22.472" y2=".961" gradientUnits="userSpaceOnUse"><stop stop-color="#0062E0"></stop><stop offset="1" stop-color="#19AFFF"></stop></linearGradient>'
}
